import { Injectable } from '@angular/core';
import { Field } from '../../models';

@Injectable()
export class UscCampaignService {

    public view_usci_new_campaign_request: string = 'view_usci_new_campaign_request2';
    public view_usci_store_update_request: string = 'view_usci_store_update_request';
    public view_usci_store_update_request_approval: string = 'view_usci_store_update_request_approval';
    public view_usci_change_request: string = 'view_usci_change_campaign_request';

    constructor() { }

    processListItems(view: string, item: any, field: Field<any>, list_items: any, formField: Field<any>[]) {
        let filtered_list_items = JSON.parse(JSON.stringify(list_items));

        if (field.key == "dl_cfd_tsur") {
            
        }

        return filtered_list_items;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/usc-campaign/usc-campaign.service.ts